import { NO_SPACE_PATTERN } from '../constants/regex';

/* 
    E.164 International Phone Format Validator
    Validates already-normalized phone numbers: +[country code][number]
    Max 15 digits after +, no formatting characters allowed
*/
export const phoneNumber = (value) => {
    if (value) {
        const cleaned = String(value).replace(/[\s\-\(\)]/g, '');

        // Allow user input without a leading '+'. We normalize to E.164 on submit.
        // Basic sanity: optional '+', then 6-15 digits.
        return /^\+?\d{6,15}$/.test(cleaned);
    }
    return true;
}
/*
    A full name must have at least two words
    *Must add .trim to v-model => v-model.trim=""
*/
export const fullName = (val) => {
    if ( val ) {
        let names = val.split(' ');
        //Name must be at least 2 words
        if ( names.length < 2 ) {
        return false;
        }
        return true;
    }
    return true;
};

/*
    Avoid double spaces in a Full Name
    "John Doe" -> valid
    "John  Doe" -> invalid
    *Must add .trim to v-model => v-model.trim=""
*/
export const noDoubleSpaceInFullName = (val) => {
    if (val) {
      let names = val.split(' ');
      let noSpaceRegex = new RegExp(NO_SPACE_PATTERN);

      for ( let i = 0; i < names.length; i++ ) {
        if ( !noSpaceRegex.test(names[i]) ) {
          return false;
        }
      }
      return true;
    }
    return true;
};


